import ServiceHero from '@/components/sections/ServiceHero'

export default function EngineeringHero() {
  return (
    <ServiceHero
      serviceName="Engineering"
      titleLines={['Web Application', 'Development']}
      description="Fast, accessible, and built to convert. We engineer digital experiences on modern tech stacks that leave legacy competitors in the dust."
    />
  )
}
